import { render } from "./ProxmoxSshKeyPairForm.vue?vue&type=template&id=5d3e95c7"
import script from "./ProxmoxSshKeyPairForm.vue?vue&type=script&lang=js"
export * from "./ProxmoxSshKeyPairForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__